export default __webpack_public_path__ + "static/media/NotoSans-Regular.1ef18564.otf";